import { CustomTypedEvent } from './events';
export class CurrentIndexChangeEvent extends CustomTypedEvent {
    constructor(args) {
        super('currentindexchange', args);
    }
}
//}
